import styled, {css, keyframes} from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {colors} from 'theme';

const opacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const ActionsContainer = styled.div`
    display: flex;
    justify-content: center;
    min-width: 60px;
    gap: 10px;
`;

export const Action = styled.div<{disabled?: boolean}>`
    padding: 5px;
    cursor: pointer;
    ${(props) =>
        props.disabled &&
        css`
            pointer-events: none;
            opacity: 0.3;
        `}
`;

export const SpinnerLayer = styled.div`
    display: flex;
    height: 100%;
    flex: 1;
    justify-content: center;
    align-items: center;
    min-height: 200px;

    animation: ${opacity} 2s ease;
`;

export const ButtonContainer = styled.div`
    display: flex;
    gap: 10px;
    width: 100%;
    justify-content: flex-end;

    & > * {
        max-width: 240px;
        width: 100%;
    }
`;

export const ButtonRemove = styled(Button)`
    background-color: ${colors.danger} !important;
    border: 1px solid ${colors.danger} !important;
    color: #ffffff !important;
`;

export const ConfirmRemoveFooter = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
`;

export const CancelConfirmButton = styled(Button)`
    border: 1px solid ${colors.danger} !important;
    color: ${colors.danger};
`;

export const SubmitConfirmButton = styled(Button)`
    background-color: ${colors.danger} !important;
    border: 1px solid ${colors.danger} !important;
`;

export const AddFooter = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
`;
